import React from 'react';
import './index.less';

export default ({ label, dic }: { label: string; dic?: string }) => {
    return (
        <div className="detailTitle">
            <b />
            <div>
                {label}
                {dic && <div className="dicStyle">{dic}</div>}
            </div>
        </div>
    );
};
